(() => {
  document.querySelectorAll('.drawer, .popover').forEach(panel => {
    const template = panel.querySelector('template[shadowmode]');
    if (template && !panel.shadowRoot) {
      const shadow = panel.attachShadow({ mode: 'open' });
      shadow.append(template.content.cloneNode(true));
      template.remove();
      shadow.addEventListener('click', event => {
        if (event.target.closest('[part="overlay"],button[aria-label="Close"]')) closePanel(panel);
      });
    }
  });
  let opener;
  function closePanel(panel) {
    panel.removeAttribute('open');
    document.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (!document.querySelector('.drawer[open]')) document.documentElement.classList.remove('ionix-home-lock');
    opener?.focus();
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[aria-controls]');
    if (control) {
      const panel = document.getElementById(control.getAttribute('aria-controls'));
      if (panel?.matches('.drawer, .popover')) {
        event.preventDefault();
        if (panel.hasAttribute('open')) closePanel(panel);
        else {
          opener = control;
          panel.setAttribute('open', '');
          control.setAttribute('aria-expanded', 'true');
          if (panel.classList.contains('drawer')) document.documentElement.classList.add('ionix-home-lock');
          panel.querySelector('input,button,a')?.focus();
        }
      }
    }
    const close = event.target.closest('button[aria-label="Close"]');
    if (close) {
      const panel = close.closest('.drawer,.popover');
      if (panel) closePanel(panel);
    }
    const option = event.target.closest('x-listbox button[value]');
    if (option) {
      const form = option.closest('form');
      const input = form?.querySelector('input[name="country_code"],input[name="locale_code"],input[name="language_code"]');
      if (input) { input.value = option.value; form.requestSubmit(); }
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.drawer[open],.popover[open]').forEach(closePanel);
  });
})();
